var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10287_33494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.678L0 6.29723e-08L2.81733 6.29723e-08L2.81733 12.678C2.81733 13.7988 3.26257 14.8737 4.0551 15.6662C4.84763 16.4588 5.92253 16.904 7.04333 16.904C8.16413 16.904 9.23903 16.4588 10.0316 15.6662C10.8241 14.8737 11.2693 13.7988 11.2693 12.678V4.226C11.2693 3.8524 11.1209 3.4941 10.8567 3.22992C10.5926 2.96574 10.2343 2.81733 9.86066 2.81733C9.48706 2.81733 9.12876 2.96574 8.86458 3.22992C8.60041 3.4941 8.452 3.8524 8.452 4.226V14.0867H5.63466L5.63466 4.226C5.63466 3.67103 5.74397 3.1215 5.95635 2.60878C6.16873 2.09606 6.48001 1.63019 6.87243 1.23777C7.26485 0.845346 7.73072 0.534061 8.24344 0.321685C8.75616 0.109309 9.3057 0 9.86066 0C10.4156 0 10.9652 0.109309 11.4779 0.321685C11.9906 0.534061 12.4565 0.845346 12.8489 1.23777C13.2413 1.63019 13.5526 2.09606 13.765 2.60878C13.9774 3.1215 14.0867 3.67103 14.0867 4.226V12.678C14.0867 14.546 13.3446 16.3375 12.0237 17.6584C10.7028 18.9793 8.91134 19.7213 7.04333 19.7213C5.17532 19.7213 3.38382 18.9793 2.06294 17.6584C0.742063 16.3375 0 14.546 0 12.678Z",
    fill: "#BEBECE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.2167 0L16.904 0V12.678C16.904 15.2932 15.8652 17.8013 14.0159 19.6505C12.1667 21.4998 9.65859 22.5387 7.04338 22.5387H2.81738L2.81738 38.034C2.81738 39.1548 3.26262 40.2297 4.05515 41.0222C4.84768 41.8147 5.92258 42.26 7.04338 42.26H35.2167C36.3375 42.26 37.4124 41.8147 38.2049 41.0222C38.9975 40.2297 39.4427 39.1548 39.4427 38.034V4.226C39.4427 3.10519 38.9975 2.03029 38.2049 1.23777C37.4124 0.445238 36.3375 0 35.2167 0ZM30.9907 11.2693H19.7214V14.0867H30.9907V11.2693ZM30.9907 19.7213H19.7214V22.5387H30.9907V19.7213ZM11.2694 28.1733H30.9907V30.9907H11.2694V28.1733Z",
    fill: "#BEBECE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10287_33494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.26,
    height: 42.26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDataIcon);
export default __webpack_public_path__ + "static/media/UploadDataIcon.4d75d33b0d5c969375bf179d4514359c.svg";
export { ForwardRef as ReactComponent };